// import { Switch } from 'antd';
import { FC } from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { ChartLegend } from './ChartLegend';
import { TChartFooterProps } from './types';

export const ChartFooter: FC<TChartFooterProps> = ({
	showDetailedData,
	setShowDetailedDataHandler,
	charts,
	colors,
}) => {
	const handleChange = () => {
		setShowDetailedDataHandler(!showDetailedData);
	};
	return (
		<Box
			style={{
				marginLeft: '55px',
				marginTop: '20px',
				padding: '0px',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: '#016193' }}>
				<Switch onChange={handleChange} checked={showDetailedData} sx={{ color: '#016193' }} />
				<Typography style={{ marginLeft: '10px' }}>Show detailed data</Typography>
			</Box>
			{showDetailedData && <ChartLegend charts={charts} colors={colors} />}
		</Box>
	);
};
